export function getPreferredOpenBankingFlowType(mobile) {
  return mobile ? "redirect" : "poll";
}

/** A desktop QR handoff needs Yapily's QR URL; otherwise use its browser URL. */
export function resolveOpenBankingFlowType(preferredFlowType, qrUrl) {
  if (preferredFlowType === "poll" && !qrUrl) {
    return "redirect";
  }

  return preferredFlowType;
}
